import React from 'react';
import NumberInput from '../../shared/NumberInput';

const fieldLabelStyle = { fontSize: 12, color: '#5a6b85', textTransform: 'uppercase', letterSpacing: 0.3, display: 'block', marginBottom: 4 };
const fieldWrapStyle = { marginBottom: 14 };

// An outermost package's Actual Postage (issue #350): what was paid to post
// it, inc GST, as the carrier's receipt shows it. Blank until it's known;
// 0 for a package that cost nothing to send. Shared by the Ship dialog and
// Edit Shipment. `value` is the amount as a string; onChange gets it back.
function ActualPostageField({ value, onChange }) {
  return (
    <div style={fieldWrapStyle}>
      <label style={fieldLabelStyle}>Actual Postage (inc GST)</label>
      <NumberInput
        decimals={2}
        step="0.01"
        min={0}
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value)}
        style={{ width: '100%', fontSize: 14 }}
      />
    </div>
  );
}

export default ActualPostageField;
